/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FeeOption } from './FeeOption';
import {
    FeeOptionFromJSON,
    FeeOptionFromJSONTyped,
    FeeOptionToJSON,
} from './FeeOption';

/**
 * 
 * @export
 * @interface TenantImmunizationFee
 */
export interface TenantImmunizationFee {
    /**
     * 
     * @type {string}
     * @memberof TenantImmunizationFee
     */
    catalog_item_id: string;
    /**
     * 
     * @type {Array<FeeOption>}
     * @memberof TenantImmunizationFee
     */
    fees?: Array<FeeOption>;
}

/**
 * Check if a given object implements the TenantImmunizationFee interface.
 */
export function instanceOfTenantImmunizationFee(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "catalog_item_id" in value;

    return isInstance;
}

export function TenantImmunizationFeeFromJSON(json: any): TenantImmunizationFee {
    return TenantImmunizationFeeFromJSONTyped(json, false);
}

export function TenantImmunizationFeeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantImmunizationFee {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'catalog_item_id': json['catalog_item_id'],
        'fees': !exists(json, 'fees') ? undefined : ((json['fees'] as Array<any>).map(FeeOptionFromJSON)),
    };
}

export function TenantImmunizationFeeToJSON(value?: TenantImmunizationFee | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'catalog_item_id': value.catalog_item_id,
        'fees': value.fees === undefined ? undefined : ((value.fees as Array<any>).map(FeeOptionToJSON)),
    };
}

